<template>
	<div id="our-services-screen">
		<services-introduction @buttonClicked="handleJoinPlatform" />
		<services-empowering />
		<services-launchpad-vision :items="benefitsList" :columns="2" :iconSize="40"
			style="border-bottom: 1px solid #6464FF;" />
		<services-launchpad-vision :title="$t('ourServicesScreen.launchpadVision.title')" :showButton="true"
			:buttonText="$t('ourServicesScreen.launchpadVision.applyButton')" :items="visionList" :columns="3"
			@applyClicked="handleJoinPlatform" />
		<services-business-crypto />
		<home-help :title="$t('ourServicesScreen.launchProject.title')"
			:description="$t('ourServicesScreen.launchProject.description')"
			:buttonText="$t('ourServicesScreen.launchProject.buttonText')" :customAction="handleJoinPlatform" />
		<div class="learn-more-background-container">
			<home-learn-more :title="$t('ourServicesScreen.blockchain.title')"
				imagePath="/images/elements/home/web/natrix-illustration.png"
				:buttonText="$t('ourServicesScreen.blockchain.buttonText')"
				:description="$t('ourServicesScreen.blockchain.description')" @buttonClicked="goToNatrix"
				:customTransform="'scale(-1, 1)'" />
		</div>
		<home-wallet :title="$t('ourServicesScreen.wallet.title')"
			:description="$t('ourServicesScreen.wallet.description')"
			:extraText="$t('ourServicesScreen.wallet.extraText')"
			imagePath="/images/elements/home/web/services-wallet.png"
			mobileImagePath="/images/elements/home/web/services-wallet-mobile.png" :hideOpenWalletPrompt="true" />
		<blog style="background-color: rgba(232, 232, 255, 1)" />
	</div>
</template>

<script>
import HomeServices from '../components/modules/home/HomeServices.vue';
import HomeWallet from '@/components/modules/home/HomeWallet';
import Blog from '@/components/modules/blog/Blog';
import HomeLearnMore from '../components/modules/home/HomeLearnMore.vue';
import ServicesIntroduction from '../components/modules/home/ServicesIntroduction.vue';
import ServicesLaunchpadVision from '../components/modules/home/ServicesLaunchpadVision.vue';
import HomeHelp from '../components/modules/home/HomeHelp.vue';
import ServicesEmpowering from '../components/modules/home/ServicesEmpowering.vue';
import ServicesBusinessCrypto from '../components/modules/home/ServicesBusinessCrypto.vue';

export default {
	name: 'OurServicesScreen',
	props: {},
	components: {
		HomeServices,
		HomeWallet,
		Blog,
		HomeLearnMore,
		ServicesIntroduction,
		ServicesLaunchpadVision,
		HomeHelp,
		ServicesEmpowering,
		ServicesBusinessCrypto,
	},
	data: () => ({}),
	created() { },
	computed: {
		benefitsList() {
			return [
				{
					icon: '/images/icons/check-member-blue.svg',
					title: this.$t('ourServicesScreen.benefits.growTrust.title'),
					description: this.$t('ourServicesScreen.benefits.growTrust.description'),
					highlighted: false,
				},
				{
					icon: '/images/icons/fast-blue.svg',
					title: this.$t('ourServicesScreen.benefits.accelerateEntry.title'),
					description: this.$t('ourServicesScreen.benefits.accelerateEntry.description'),
					highlighted: false,
				},
				{
					icon: '/images/icons/easy-trading-blue.svg',
					title: this.$t('ourServicesScreen.benefits.issueDistribute.title'),
					description: this.$t('ourServicesScreen.benefits.issueDistribute.description'),
					highlighted: false,
				},
				{
					icon: '/images/icons/circle-member-blue.svg',
					title: this.$t('ourServicesScreen.benefits.communityEngagement.title'),
					description: this.$t('ourServicesScreen.benefits.communityEngagement.description'),
					highlighted: false,
				},
			];
		},
		visionList() {
			return [
				{
					icon: '/images/icons/rocket.svg',
					title: this.$t('ourServicesScreen.launchpadVision.items.fintech.title'),
					description: this.$t('ourServicesScreen.launchpadVision.items.fintech.description'),
					highlighted: false,
				},
				{
					icon: '/images/icons/business.svg',
					title: this.$t('ourServicesScreen.launchpadVision.items.realEstate.title'),
					description: this.$t('ourServicesScreen.launchpadVision.items.realEstate.description'),
					highlighted: false,
				},
				{
					icon: '/images/icons/star.svg',
					title: this.$t('ourServicesScreen.launchpadVision.items.brands.title'),
					description: this.$t('ourServicesScreen.launchpadVision.items.brands.description'),
					highlighted: true,
				},
				{
					icon: '/images/icons/person.svg',
					title: this.$t('ourServicesScreen.launchpadVision.items.community.title'),
					description: this.$t('ourServicesScreen.launchpadVision.items.community.description'),
					highlighted: false,
				},
				{
					icon: '/images/icons/music.svg',
					title: this.$t('ourServicesScreen.launchpadVision.items.music.title'),
					description: this.$t('ourServicesScreen.launchpadVision.items.music.description'),
					highlighted: false,
				},
				{
					icon: '/images/icons/ball.svg',
					title: this.$t('ourServicesScreen.launchpadVision.items.sports.title'),
					description: this.$t('ourServicesScreen.launchpadVision.items.sports.description'),
					highlighted: false,
				},
			];
		},
	},
	methods: {
		goToNatrix() {
			console.log('natrix');
			window.open('https://natrix.io/', '_blank');
		},
		handleJoinPlatform() {
			this.$router.push('/joinplatform');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_fonts.scss';
@import '@/assets/scss/_colors.scss';

#our-services-screen {
	position: relative;
	background: #e8e8ff;

	&::v-deep {
		.header-background {
			position: absolute;
			top: 0;
			right: 0;

			.header-web-background {
				height: 635px;
			}

			.header-mobile-background {
				width: 100vw;
			}
		}

		.jumbotron {
			position: relative;

			.col-md-6 {
				position: unset;
			}

			.illustration {
				position: absolute;
				width: 540px;
				height: 540px;
				right: 150px;

				@media (max-width: 1200px) {
					right: 70px !important;
				}

				@media (max-width: $breakpoint-md) {
					bottom: -50px;
					width: 415px !important;
					right: 30px !important;
				}
			}

			.jumbotron-top-image img {
				margin-top: 60px;
				max-height: 370px;

				@media (max-width: $breakpoint-md) {
					margin-top: 0;
				}
			}

			.top-section {
				@media (max-width: $breakpoint-sm) {
					padding: 60px 45px 0 0 !important;
				}
			}
		}

		.left-container {
			max-width: 540px;
		}

		.text {
			font-size: $text-l;
			color: $black;
			line-height: 20px;
		}

		.light-purple-row {
			background-color: $lighter-purple;
		}

		.ebso-gold-backing-row {
			background-color: #f6f4ff;
		}

		#home-wallet {
			background-image: url('/images/elements/home/web/wallet_background.png');

			.wallet-image-wrapper {
				justify-content: end;

				@media (max-width: $breakpoint-md) {
					justify-content: center;
				}

				@media (max-width: $breakpoint-lg) {
					min-height: unset;
				}

				.wallet-image {
					margin-right: 38px;
					margin-bottom: 0px;
					max-height: 554px;

					@media (max-width: $breakpoint-lg) {
						margin-right: 0px;
						max-height: 564px;
					}
				}
			}

			.wallet-row {
				flex-direction: row !important;

				.wallet-col {
					align-items: flex-start !important;

					@media (max-width: $breakpoint-sm) {
						align-items: center !important;
					}

					.title {
						text-align: left !important;

						@media (max-width: $breakpoint-sm) {
							text-align: center !important;
						}
					}

					.text {
						text-align: left !important;

						@media (max-width: $breakpoint-sm) {
							text-align: center !important;
						}
					}
				}
			}
		}

		.title {
			@media (max-width: $breakpoint-xs) {
				font-size: 28px;
				line-height: 30px;
			}
		}
	}
}

.bb-logo-container {
	max-width: 1126px;
	position: absolute;
	top: 1.6%;
	left: 50%;
	transform: translateX(-50%);

	@media (max-width: 1200px) {
		max-width: 960px;
		top: 1.2%;
	}

	@media (max-width: 992px) {
		max-width: 720px;
		top: 1.2%;
	}
}

.learn-more-background-container {
	position: relative;
	width: 100%;
	height: auto;
	background: url('/images/elements/home/web/services-learn-more.png') no-repeat center center;
	background-size: cover;
	background-position: center;
	
	&::v-deep {
		.content-container {
			background: unset !important;
		}
		.natrix-web-illustration {
			width: 445px;
		}

		.natrix-mobile-illustration {
			width: 300px;
		}
	}

	@media (max-width: $breakpoint-md) {
		background: url('/images/elements/home/web/services-learn-more-mobile.png') no-repeat center center;
		background-size: cover;
		background-position-y: 40%;
	}

	@media (max-width: $breakpoint-xs) {
		background-position-y: unset;
	}
}

.header-background-image {
	background: url('/images/elements/home/web/home_background.png') no-repeat center center;
}
</style>
